module.exports = __webpack_public_path__ + "static/media/forum_default_header.f9044d35.svg";